<template>
    <q-card class="bg-grey-1">
        <q-card-media v-if="podcast.type == 'podcast'">
            <div class="container">
                <img class="thumb image" :src="podcast.image_large" v-if="podcast.image_large">
                <img class="thumb image" :src="getPlaceholder" v-if="!podcast.image_large">

                <div class="middle">
                    <q-btn flat round icon="fal fa-play" size="1.5rem" @click="playPlaylist" />
                </div>
            </div>
        </q-card-media>

        <q-card-main class="relative-position">
            <div class="line-card bg-primary absolute-top"></div>

            <div class="row q-my-sm" v-if="podcast.type == 'podcast'">
                <div class="col-10">
                    <div class="row">
                        <div class="col-12 q-title text-weight-medium">
                            {{ podcast.title }}
                        </div>

                        <div class="col-12 q-mb-md">
                            <q-rating color="amber" slot="subtitle" icon="fas fa-star" v-model="podcast.avg_stars" :max="5" readonly />
                        </div>
                    </div>
                </div>

                <div class="col-2" >
                    <vc-donut :sections="setSections" :size="100" unit="%">

                        <h6>
                            {{ getPercentage(podcast.user_progress) }}%
                        </h6>
                    </vc-donut>
                </div>

                <div class="col-12" >
                    <div class="col-12">
                        <div class="row">
                            <div class="col-6">
                                <p class="caption" v-if="podcast.areas.length > 0">
                                    {{ $t('areas') }}
                                </p>
                                <p v-if="podcast.areas.length > 0" class="tooltip q-mb-sm">
                                    <span v-for="(area, index) in podcast.areas" :key="index">
                                        {{ getArea(area) }}<span v-if="(podcast.areas.length - 1) > index">, </span>
                                    </span>
                                </p>

                                <p class="caption" v-if="podcast.user_groups.length > 0">
                                    {{ $t('groups') }}
                                </p>
                                <p v-if="podcast.user_groups.length > 0" class="tooltip q-mb-sm">
                                    <span v-for="(group, index) in podcast.user_groups" :key="index">
                                        {{ getGroup(group) }}<span v-if="(podcast.user_groups.length - 1) > index">, </span>
                                    </span>
                                </p>
                            </div>

                            <div class="col-6 ">
                                <p class="caption" v-if="podcast.tags.length > 0">
                                    {{ $t('tags') }}
                                </p>
                                <p class="tooltip q-mb-sm">
                                    <span v-for="(tag, index) in podcast.tags" :key="index">
                                        {{ getTag(tag) }}<span v-if="(podcast.tags.length - 1) > index">, </span>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="row q-my-sm" v-if="podcast.type == 'user_podcast'">
                <div class="col-7">
                    <div class="row">
                        <div class="col-12 q-title text-weight-medium">
                            <q-btn v-if="podcast.type == 'user_podcast'" flat round icon="fal fa-play" @click="playPlaylist" />
                            {{ podcast.title }}
                        </div>
                    </div>
                </div>
                <div class="col-5 text-right" >
                    <q-btn flat round color="primary" icon="far fa-pencil-alt" @click="clickAddPlaylist()"/>
                    <q-btn flat round color="negative" icon="far fa-trash-alt" @click="confirmRemove('remove_playlist')" />
                </div>
            </div>


            <q-card-actions v-if="podcast.type == 'podcast' && actions.length > 0">
                <p class="text-center fit">
                    <q-btn flat v-for="(action, index) in actions" :key="index" :icon="action.icon" :label="getLabel(action.label)" :color="getColor(action.slug)" @click="doAction(action.slug)">
                        <q-tooltip>
                            {{ $t(action.tooltip) }}
                        </q-tooltip>
                    </q-btn>
                </p>
            </q-card-actions>
        </q-card-main>

        <q-card-separator />

        <q-card-actions>
            <q-list class="full-width" no-border>
                <q-collapsible icon="fal fa-album-collection" :label="`${podcast.podcast_playlist_audio.length} ${$t('audios')}`">
                    <q-list class="full-width" dense separator>
                        <q-item :style="cursor" :class="getClassline(audio)" @click.native="addUserPlaylist(audio)" v-for="(audio, index) in podcast.podcast_playlist_audio" :key="index">
                            <q-item-side>
                                <q-item-tile>
                                    <q-btn flat round icon="fal fa-play" @click.stop="playAudio(audio)" />
                                </q-item-tile>
                            </q-item-side>

                            <q-item-main :label="audio.title" />

                            <q-item-side right v-if="podcast.type == 'podcast'">
                                <q-icon name="fal fa-check-circle" size="1.5rem" color="positive" v-if="audio.progress_audio_listen_status == 2"/>
                                <q-icon name="fal fa-circle" size="1.5rem" color="primary" v-else/>
                            </q-item-side>

                            <q-item-side right v-if="podcast.type == 'user_podcast'">
                                <q-btn flat round color="negative" icon="far fa-trash-alt" @click="confirmRemove('remove_music', index)" />
                            </q-item-side>

                        </q-item>
                    </q-list>
                </q-collapsible>
            </q-list>
        </q-card-actions>

        <add-playlist :show="show_modal_add_plalist" :podcast="podcast"  @hideModalPlayList="hideModalPlayList"/>

        <q-dialog v-model="confirm_remove">
            <span slot="title">{{ $t('remove_item') }}</span>

            <span slot="message">{{ $t('confirm_remove_item') }}</span>

            <template slot="buttons" slot-scope="props">
                <q-btn color="primary" :label="$t('cancel')" @click="confirm_remove = false" />
                <q-btn color="negative" :label="$t('remove')" v-if="type_remove == 'remove_playlist'" @click="deletePlayList()" />
                <q-btn color="negative" :label="$t('remove')" v-if="type_remove == 'remove_music'" @click="deleteMusic()" />
            </template>
        </q-dialog>
    </q-card>

</template>

<script>
import { mapGetters } from 'vuex'
import { colors } from 'quasar'
import { debounce } from 'quasar'
import AddPlayLists from 'components/podcasts/AddPlayLists'
export default {
    props: ['podcast'],
    components: {
        'add-playlist': AddPlayLists,
    },

    data() {
        return {
            option: [],
            type_remove: '',
            index_music: '',
            confirm_remove: false,
            show_modal_add_plalist: false,
            selected_client_params: []
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            all_tags: 'site_lists/tags',
            all_areas: 'site_lists/country_areas',
            group_users: 'site_lists/group_users_labels',
            clients: 'params/clients',
            params_loaded: 'params/params_loaded',
            id_user_client_selected: 'common/id_user_client_selected',
            progress_audio: 'podcasts/progress_audio',
            playlist: 'podcasts/playlist',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getPlaceholder() {
            if (!this.selected_client_params.podcast_placeholder) return ''
            else return this.selected_client_params.podcast_placeholder
        },

        setSections() {
            return [{
                value: this.podcast.user_progress ? this.podcast.user_progress > 100 ? 100 : this.podcast.user_progress : 0,
                color: this.getDonutColor(this.podcast.user_progress)
            }]
        },

        playlistMusic: {
            get: function() {
                return this.playlist
            },
            set: function(value) {
                this.$store.dispatch('podcasts/SET_PLAYLIST', [value])
            }
        },

        cursor() {
            if(this.podcast.type == 'podcast') return "cursor: pointer";
            else return ""
        },

        actions() {
            let actions = []
            let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
            if(obj) {
                actions.push({
                    icon: 'fal fa-thumbs-up',
                    label: 'likes',
                    tooltip: 'likes',
                    slug: 'likes'
                })
                if(obj.use_comments_podcast) {
                    actions.push({
                        icon: 'fal fa-star',
                        label: 'stars',
                        tooltip: 'add_comment',
                        slug: 'stars'
                    })
                }
                actions.push({
                    icon: 'fal fa-heart',
                    label: 'favorite',
                    tooltip: 'add_favorite',
                    slug: 'favorite'
                })
            }
            return actions
        }
    },

    methods: {
        playPlaylist() {
            this.$store.dispatch('podcasts/SET_TYPE_LIST', [this.podcast.type])
            this.$emit('playPlaylist', this.podcast)
        },

        playAudio(audio) {
            this.$store.dispatch('podcasts/SET_TYPE_LIST', [this.podcast.type])
            this.$emit('playAudio', [this.podcast, audio])
        },

        getArea(id) {
            let obj = this.all_areas.find((obj) => { return obj.value === id })
            if (obj) return obj.label
            else return ''
        },

        getGroup(id) {
            let obj = this.group_users.find((obj) => { return obj.value === id })
            if (obj) return obj.label
            else return ''
        },

        getTag(id) {
            let obj = this.all_tags.find((obj) => { return obj.value === id })
            if (obj) return obj.label
            else return ''
        },

        getDonutColor(percentage) {
            if (percentage > 0 && percentage <= 24) {
                return '#DB2828'
            }
            else if (percentage >= 25 && percentage <= 74) {
                return '#F2C037'
            }
            else if(percentage >= 75) {
                return '#21BA45'
            }
        },

        getPercentage(percentage) {
            if (!percentage) return 0
            else if (percentage < 100) return parseInt(percentage)
            else return parseInt(percentage)
        },

        getLabel(label) {
            switch(label) {
                case 'score': return this.podcast.score
                break
                case 'likes': return this.podcast.likes
                break
                case 'stars': return `${this.podcast.avg_stars} / 5`
                break
            }
        },

        getColor(slug) {
            if (slug == 'likes') {
                if (this.podcast.liked) return 'secondary'
                else return ''
            }
            else if (slug == 'stars') {
                if (this.podcast.starred) return 'secondary'
                else return ''
            }
            else if (slug == 'favorite') {
                if (this.podcast.favorited) return 'negative'
                else return ''
            }
            else {
                return ''
            }
        },

        doAction(slug) {
            if (slug == 'likes') {
                this.likeItem()
            }
            else if (slug == 'stars') {
                this.$emit('clickStars', this.podcast.id)
            }
            else if (slug == 'favorite') {
                this.favoriteItem()
            }
        },

        clickAddPlaylist() {
            this.show_modal_add_plalist = true
        },

        hideModalPlayList(type) {
            this.show_modal_add_plalist = false
            if(type == 'add-playlist') this.$emit('fetchUserPodcast', '')
        },

        confirmRemove(type, index) {
            this.type_remove = type
            if(this.type_remove == 'remove_music') this.index_music = index
            this.confirm_remove = true
        },

        deletePlayList() {
            this.confirm_remove = false
            this.$q.loading.show()

            this.$axios.delete(`/etraining_podcast/playlist_user/${this.podcast.id}/`, this.getHeader)
            .then(response => {
                this.type_remove = ''
                this.$emit('fetchUserPodcast', '')
                this.$q.notify({
                        message: this.$t('playlist_save_success'),
                        type: 'positive',
                        icon: 'fal fa-save'
                    })
            })
            .catch(e => {
                console.log(e)
                this.$q.notify({
                        message: this.$t('unexpected_error_try_again_later'),
                        type: 'negative',
                        icon: 'fal fa-ban'
                    })
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        deleteMusic() {
            this.confirm_remove = false
            this.$q.loading.show()

            if(this.podcast.podcast_playlist_audio.length == 1){
                this.deletePlayList()
                return
            }

            let playlist = []
            this.podcast.podcast_playlist_audio.map((a, index) => {
                if(index != this.index_music) {
                    playlist.push(a.id)
                }
            })

            let fd = {
                'title': this.podcast.title,
                'audios': playlist
            }

            this.$axios.put(`/etraining_podcast/playlist_user/${this.podcast.id}/`, fd, this.getHeader)
                .then(response => {
                    this.$emit('fetchUserPodcast', '')
                    this.$q.notify({
                        message: this.$t('playlist_save_success'),
                        type: 'positive',
                        icon: 'fal fa-save'
                    })
                })
                .catch(e => {
                    console.log(e)
                    this.$q.notify({
                        message: this.$t('unexpected_error_try_again_later'),
                        type: 'negative',
                        icon: 'fal fa-ban'
                    })
                })
                .finally(() => {
                    this.type_remove = ''
                    this.$q.loading.hide()
                })
        },

        addUserPlaylist(audio) {
            if(this.podcast.type == 'podcast') {
                let playlist_id = this.playlist.map(e => e.id)
                if(playlist_id.indexOf(audio.id) == -1) {
                    this.$store.dispatch('podcasts/SET_PLAYLIST', [[...this.playlist, audio]])
                }
                else {
                    let playlist = []
                    this.playlist.map( e =>  (e.id != audio.id ? playlist.push(e) : '') )
                    this.$store.dispatch('podcasts/SET_PLAYLIST', [playlist])
                }
            }
        },

        getClassline(audio) {
            if(this.podcast.type == 'podcast'){
                if(this.playlist.includes(audio))  return 'bg-green-1'
                else return ''
            }
        },

    },

    mounted() {
        this.likeItem = debounce(() => {
            this.$emit('clickLike', this.podcast.id)
        }, 500)

        this.favoriteItem = debounce(() => {
            this.$emit('clickFavorite', this.podcast.id)
        }, 500)
    },

    created() {
        let client = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
        this.selected_client_params = client ? client : {}
    },

    watch: {
        progress_audio:{
            handler: function(progress_audio) {
                this.podcast.podcast_playlist_audio.map(a => {
                     if(a.id == progress_audio.audio.id && progress_audio.audio.status_progress == 2) {
                        a.current_time = progress_audio.audio.current_time
                        a.progress = progress_audio.audio.progress
                        a.progress_audio_listen_status = progress_audio.status_progress
                    }
                })
            }, deep:true
        },
    },
}
</script>

<style lang="stylus" scoped>
.line-card
    border-top: 3px solid transparent
    border-top-left-radius inherit
    border-top-right-radius inherit

p
    margin 0 0 5px

.thumb
    width 100%
    height auto

.container
    position relative
    width 100%
    &:hover
        .image
            opacity 0.3
        .middle
            opacity 1

.image
    opacity 1
    display block
    width 100%
    height auto
    transition .5s ease
    backface-visibility hidden

.middle
    transition .5s ease
    opacity 0
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    -ms-transform translate(-50%, -50%)
    text-align center
</style>
